export default "__VITE_ASSET__tnT4BO0snf$qyLlVuWmbWw__"